import "../css/style.scss";
import "swiper/css/bundle";
 
import { isMobile } from "./Module/Helper";
 
import { init, initBeforeEnter  } from "./Module/init";

import { lenis, lenisScroll } from "./Module/lenis/lenis";
const lss = new lenisScroll();


if (!isMobile()) lss.initLenis();

init();
initBeforeEnter();





const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
    }
  });
});

document.querySelectorAll('.separator.animate-on-scroll').forEach(el => {
  observer.observe(el);
});